import React, { useEffect, useState } from 'react';
import styles from './Header.module.css'; // Import corect al CSS-ului
import logoEnergy5Negative1 from 'assets/lp/logoenergy5.png'

const Header: React.FC = () => {
  const [isSticky, setIsSticky] = useState(false);

  // Funcție pentru a verifica dacă trebuie să facem header-ul sticky
  const handleScroll = () => {
    if (window.scrollY > 50) { // Când scroll-ul depășește 50px
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  // Adăugăm event listener pentru scroll
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    // Cleanup la unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`${styles.header} ${isSticky ? styles.sticky : ''}`}>
      <div className={styles.headerWrapper}>
        <div className={styles.logoheader}>
          <img src={logoEnergy5Negative1} alt="Logo Energy5" />
        </div>
      </div>
    </header>
  );
};

export default Header;
